import styled from 'styled-components';

export const FormWrapper = styled('div')`
    display: flex;
    background: none;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    overflow: auto;
    flex-direction: column;
    padding: 3.2rem 0 18.6rem;
    gap: 2.4rem;
    flex: 1;

    & > div:not(:last-child) {
        width: 100%;
        max-width: 44rem;
        margin: 0 auto;
        padding: 0 2.4rem;
        min-height: fit-content;
        box-sizing: border-box;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.L.min}px) {
        margin: 3.6rem auto;
        max-width: 84.4rem;
        border-radius: 0.8rem;
        background-color: ${({ theme }) => theme.colors.white};
        height: auto;
        padding: 3.2rem 0 0;
        max-height: 80%;
        z-index: 2;

        & > div:not(:last-child) {
            margin: 0;
            max-width: 100%;
            padding: 0 4.8rem;
        }
    }
`;
